@if (data(); as data) {
    <div class="card">
        <div class="bg-image" [ngClass]="{ 'bg-image--none': !data.backgroundImage }">
            @if (data.backgroundImage) {
                <app-image
                    [image]="data.backgroundImage"
                    [width]="341"
                    [height]="560"
                    [style]="{
                        'height': '100%',
                        'objectFit': 'cover'
                    }"
                    crop="crop"
                ></app-image>
            }
        </div>

        <div class="wrapper" [ngClass]="{
            'wrapper--top': data.linkAlignment === 'Top',
            'wrapper--bottom': data.linkAlignment === 'Bottom',
            'wrapper--center': data.linkAlignment === 'Center'
        }">
            <div class="content" [ngClass]="{
                'content--top': data.linkAlignment === 'Top',
                'content--center': data.linkAlignment === 'Center'
            }">
                <h5 [innerHTML]="data.title" [style.color]="'#' + (data.textColor || 'FFF')"></h5>
            </div>

            @if (data.showLink) {
                <div class="actions" [ngClass]="{
                    'actions--top': data.linkAlignment === 'Top',
                    'actions--bottom': data.linkAlignment === 'Bottom',
                    'actions--center': data.linkAlignment === 'Center'

                }">
                    @if (data.link?.url) {
                        <ng-container *ngTemplateOutlet="link; context: { data: data, showText: true }"></ng-container>
                    }
                </div>
            }
        </div>

        @if (data?.link && !data?.showLink) {
            <ng-container *ngTemplateOutlet="link; context: { data: data }"></ng-container>
        }
    </div>
}

<!-- yes... looks reinventing the wheel, but we want maintain the routerLink functionality and also the possibility to open in a new tab without losing it -->
<ng-template #link let-data="data" let-showText="showText">
    @if (data.link?.target !== '_blank') {
        <a [routerLink]="data.link?.url"
           (click)="uspCardClick(data)"
           title="{{ data.link?.name || '' }}"
           [ngClass]="{
                'kk-link-cover': !showText,
                'kk-btn action-link': showText
           }"
        >
            @if (showText) {
                {{ data.link?.name }}
            } @else {
                <span class="kk-visuallyhidden">{{ data.link?.name || '' }}</span>
            }
        </a>
    } @else {
        <a [href]="data.link?.url"
           (click)="uspCardClick(data)"
           [target]="data.link?.target ?? '_self'"
           title="{{ data.link?.name || '' }}"
           [ngClass]="{
                'kk-link-cover': !showText,
                'kk-btn action-link': showText
           }"
        >
            @if (showText) {
                {{ data.link?.name }}
            } @else {
                <span class="kk-visuallyhidden">{{ data.link?.name || '' }}</span>
            }
        </a>
    }
</ng-template>
